import React from 'react';
import withStaticBuilder from 'StaticBuilder/hocs/StaticBuilderField';
import PropTypes from 'prop-types';
import CustomPropTypes from 'CustomPropTypes';

// in order to pass in data even if nothing is selected, create hidden input field
class MultiSelectCheckList extends React.Component {
  constructor(props) {
    super(props);

    this.isChecked = this.isChecked.bind(this);
    this.getOptionName = this.getOptionName.bind(this);
  }

  getOptionName() {
    if (this.props.isSelfServe) {
      return `${this.props.id}[]`;
    }
    return this.props.id;
  }

  isChecked({ id, value }) {
    if (id) {
      return !!this.props.selectedValues[id];
    }
    return !!this.props.selectedValues[value];
  }

  render() {
    return (
      <React.Fragment>
        {
          !this.props.isSelfServe &&
            <input
              key={`${this.props.id}`}
              type="hidden"
              name={`${this.props.id}`}
              value="--"
            />
        }
        {
          this.props.options.map(option => (
            <label
              key={`${this.props.id}_${option.value}`}
              className="checkbox"
              htmlFor={this.props.id}
            >
              <input
                type="checkbox"
                name={this.getOptionName()}
                onChange={this.props.onChange}
                value={option.value}
                checked={this.isChecked(option)}
              />
              {option.text}
            </label>
          ))
        }
      </React.Fragment>
    );
  }
}

MultiSelectCheckList.defaultProps = {
  isSelfServe: false,
};

MultiSelectCheckList.propTypes = {
  id: PropTypes.string.isRequired,
  selectedValues: CustomPropTypes.shapeWithBooleanValues.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      text: PropTypes.string,
      value: PropTypes.string,
    }),
  ).isRequired,
  isSelfServe: PropTypes.bool,
};

export default withStaticBuilder(MultiSelectCheckList);



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/MultiSelectCheckList.jsx